var _text, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMarkWithTextBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261.91 80.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#1D1D26",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 39.28,
    fontWeight: 800,
    letterSpacing: ".2em",
    transform: "matrix(.99999781 -.00209439 .00209439 .99999781 95.24 55.82)"
  }, "A", /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: ".2em",
    x: 36.39,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: ".19em",
    x: 66.83,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: ".23em",
    x: 96.81,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: ".2em",
    x: 130.42,
    y: 0
  }, "A"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m81.79 51.63-25.69-12 18.9-23.23-27.44 13-6.72-29.4-6.62 29.42-27.57-12.87 19 23.15-25.65 12.11 29 .63-6.31 28.3 18.2-22.39 1.59 1.91 16.91 20.56-6.52-28.43zm-63.24-25.84 18 8.41 4.3-19.13 3.59 15.75-15.7 7.41zm-4.32 23 42.08-19.88-25.81 20.23zm14.77 18.85 3.55-15.87 25.82-20.23zm24 .13-8.45-10.23-1.55-1.83 10.92-13.41 2.22 1 11.41 5.32-18.85.5z",
    fill: "#1D1D26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.87 58.35 1.59 1.91.15.18 2.16-2.64-.22-.26-1.53-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7 49.16.68 2.97 2.49-3.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.92 42.3 2.22 1.04.29.13 2.17-2.67-2.51-1.17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkWithTextBlack);
export default __webpack_public_path__ + "static/media/logo-mark-with-text-black.7d2da551586236231d12ccd48a894915.svg";
export { ForwardRef as ReactComponent };